import { Typography } from "@mui/material";
import AppLogoSpinning from "./AppLogoSpinning";

const FAQ = () => {
    return <div>
        <Typography marginBottom={"30px"}>FAQ</Typography>
        <AppLogoSpinning/>
    </div>
}

export default FAQ;
